/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';
import {
  NbActionsModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbSpinnerModule,
  NbThemeModule,
  NbCardModule,
} from '@nebular/theme';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';

import {
  FooterComponent,
  HeaderComponent,
  SearchInputComponent,
} from './components';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { OneColumnLayoutComponent, PopOutLayoutComponent } from './layouts';
import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
  StockGroupPipe,
  ZeroPipe,
} from './pipes';
import { EnvironmentWarningComponent } from './components/environment-warning/environment-warning.component';

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbSpinnerModule,
  NbEvaIconsModule,
  ReactiveFormsModule,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  EnvironmentWarningComponent,
  ConfirmationDialogComponent,
  SearchInputComponent,
  OneColumnLayoutComponent,
  PopOutLayoutComponent,
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  ZeroPipe,
  NumberWithCommasPipe,
  StockGroupPipe,
];

@NgModule({
  imports: [CommonModule, ...NB_MODULES, NbCardModule],
  exports: [CommonModule, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...PIPES],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [...NbThemeModule.forRoot({ name: 'elivestock' }).providers],
    };
  }
}
